"use client";
import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "@/components/Button";
import styled from "styled-components";
import { useQueryClient } from "@tanstack/react-query";
import { modalHelper } from "@/components/services/QueryDataHelper";

const StyledIframe = styled.iframe`
  min-height: 800px;
  width: 100%;
  height: 100%;
`
const BookDiv = styled.div`
  text-align:center;
  min-height: 800px;
  width: 100%;
  height: 100%;
  background-image: url("/assets/images/book_toc.jpg");
  background-repeat: no-repeat;
  background-size: contain;
  position:relative;
  button {
    position:absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%);
  }
`

function BookPage() {
  const queryClient = useQueryClient();
  const { setModal } = modalHelper(queryClient);  
  const [ bookUrl, setBookUrl ] = useState("");

  useEffect(() => {
    if(localStorage["bookUrl"]) 
    {
      setBookUrl(localStorage["bookUrl"]); 
    }
    else
    {
      setModal("freebook");
      // Hook up the event handler
      window.addEventListener("storage", storageEventHandler);
    }    

    // Respond to the `storage` event
    function storageEventHandler(event: any) {
      if(localStorage["bookUrl"]) 
      {
        setBookUrl(localStorage["bookUrl"]); 
      } 
    }
  
    return () => {
        // Remove the handler when the component unmounts
        window.removeEventListener("storage", storageEventHandler);
    };
  }, [])  

  return (
    <section className="StyledSection">
      <Container>
        <Row>
          <Col>
            <Card bg="trans-white">
              <Card.Body>
                <Card.Title><h1 className="blue-color">Real Estate Book - Selling Secrets You Can"t Afford to Miss</h1></Card.Title>
                <Card.Text as="div">
                  {bookUrl === "" ?
                    <BookDiv>
                      <Button className="mb-4" size="lg" variant="orange" onClick={() => setModal("freebook")} title={`Request free access to our book: Selling Secrets You Can"t Afford to Miss`} aria-label={`Request free access to our book: Selling Secrets You Can"t Afford to Miss`}>
                        Request Access <i role="presentation" className="bi bi-caret-right-fill"></i>
                      </Button> 
                    </BookDiv>
                    :
                    <StyledIframe id="book-frame" width="100%" height="100%" src={bookUrl} allowFullScreen allow="autoplay" scrolling="no"></StyledIframe>  
                  }                        
                </Card.Text>                                                              
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>       
    </section>
  );
}

  
  export default BookPage;